import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Industries from "@/components/sections/Industries";
import EdKonect from "@/components/sections/EdKonect";
import Grubpe from "@/components/sections/Grubpe";
import Clients from "@/components/sections/Clients";
import Methodology from "@/components/sections/Methodology";
import Technologies from "@/components/sections/Technologies";
import Team from "@/components/sections/Team";
import Contact from "@/components/sections/Contact";

const Landing = () => {
  return (
    <div data-testid="landing-page" className="bg-white text-[#0a0a0a]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Industries />
        <EdKonect />
        <Grubpe />
        <Clients />
        <Methodology />
        <Technologies />
        <Team />
        <Contact />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
